<template>
  <div>
    <nav class="indigo darken-4">
      <div
        class="nav-wrapper indigo darken-4"
        v-if="this.$store.state.contador != 0"
      >
        <a class="brand-logo">
          <i class="material-icons">home</i>Portal Posgrados
        </a>
        <ul class="right hide-on-med-and-down">
          <a @click="menu(0)">
            <i class="material-icons">account_circle</i> Cerrar sesión
          </a>
        </ul>
      </div>
    </nav>
  </div>
</template>
<script>
export default {
  methods: {
    menu(x) {
      this.$store.state.contador = x;
    },
  },
  mounted() {
    M.AutoInit();
  },
  created() {
    var URLactual = window.location;
    let x = URLactual + "crudPortal/";
    this.$store.state.url = x;
  },
};
</script>